export const Defaults: { [index: string]: { introistField: string; integrationField: string }[] } =
  {
    googleworkspace: [
      {
        introistField: "firstname",
        integrationField: "name.givenName"
      },
      {
        introistField: "lastname",
        integrationField: "name.familyName"
      },
      {
        introistField: "emailwork",
        integrationField: "primaryEmail"
      },
      {
        introistField: "initialpassword",
        integrationField: "password"
      }
    ]
  };
